export function endpointWithUserId(endpoint: string, userId: string | null | undefined): string {
  if (userId === '' || userId == null) {
    return endpoint;
  }
  return `${endpoint}?id=${encodeURIComponent(userId)}`;
}

export function endpointWithVersion(endpoint: string, platform: string, version?: string): string {
  if (endpoint.includes('?')) {
    return `${endpoint}&platform=${platform}${version == null ? '' : `&version=${version}`}`;
  }
  return `${endpoint}?platform=${platform}${version == null ? '' : `&version=${version}`}`;
}
